import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { authApi } from '../api';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) { navigate('/'); return; }
    authApi.checkSetup().then(res => {
      if (res.data.setupRequired) navigate('/setup');
    }).catch(() => {});
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      if (!err.response) {
        setError('Server nicht erreichbar. Bitte WLAN-Verbindung prüfen.');
      } else if (err.response.status === 429) {
        const wait = err.response.data?.retry_after;
        setError(wait
          ? `Zu viele Anmeldeversuche. Bitte ${Math.ceil(wait / 60)} Minute(n) warten.`
          : 'Zu viele Anmeldeversuche. Bitte später versuchen.');
      } else if (err.response.status === 401) {
        setError('Ungültige E-Mail-Adresse oder Passwort.');
      } else {
        setError('Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
      }
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0f172a',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 56, marginBottom: 12 }}>📋</div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#f1f5f9' }}>Vertragsmanager</h1>
          <p style={{ color: '#64748b', marginTop: 4 }}>Anmelden</p>
        </div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <input
            type="email" value={email} onChange={e => setEmail(e.target.value)}
            placeholder="E-Mail" required
            autoComplete="email"
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck={false}
            style={inputStyle}
          />
          <input
            type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Passwort" required
            autoComplete="current-password"
            style={inputStyle}
          />
          {error && <p style={{ color: '#f87171', fontSize: 14, textAlign: 'center' }}>{error}</p>}
          <button type="submit" disabled={loading} style={btnStyle}>
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}

const inputStyle = {
  background: '#1e293b', border: '1px solid #334155', color: '#f1f5f9',
  padding: '12px 16px', borderRadius: 8, fontSize: 16, outline: 'none',
};
const btnStyle = {
  background: '#818cf8', color: 'white', border: 'none',
  padding: '14px', borderRadius: 6, fontSize: 16, fontWeight: 600,
  cursor: 'pointer', marginTop: 8, minHeight: 44,
};
